export const isPartner = (accountId: string) => {
    return Boolean(accountId) && accountId.endsWith("00000");
};
